// extracted by mini-css-extract-plugin
module.exports = {"table":"properties_table__W57L6","row":"properties_row__2gYMs","key":"properties_key__1nH2I","value":"properties_value__3-85K"};